import { render } from "./CharaktereTab.vue?vue&type=template&id=e870422e"
import script from "./CharaktereTab.vue?vue&type=script&lang=js"
export * from "./CharaktereTab.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__